import { ButtonProps } from 'shared/components/button/types/button-interface'
import { LinkType } from 'shared/components/link-without-prefetch'

export const isLink = (props: ButtonProps | LinkType): props is LinkType => 'href' in props
